module.exports = __webpack_public_path__ + "static/img/bg.bf3f2149.jpg";